export enum SlideId {
  Introduction = 'Introduction',
  CatDeeleyVideo = 'CatDeeleyVideo',
  IntroducingUtilityWarehouse = 'IntroducingUtilityWarehouse',
  WhereShallWeStart = 'WhereShallWeStart',
  MonthlyIncome = 'MonthlyIncome',
  CatDeeleyVideoB = 'CatDeeleyVideoB',
  AwardWinningServices = 'AwardWinningServices',
  GoUnlimited = 'GoUnlimited',
  CashbackCard = 'CashbackCard',
  WelcomeBonus = 'WelcomeBonus',
  Households = 'Households',
}
